import { QueryKey } from "@tanstack/react-query";

export const clubAsMemberQueryKeys = {
  all: () => ["clubAsMember"] as QueryKey,
  cancellationReason: () =>
    [...clubAsMemberQueryKeys.all(), "cancellationReason"] as QueryKey,
};
